import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import NivelesAcademicosView from './NivelesAcademicosView';
import * as ROUTES from '../../../router/Routes';

const NivelesAcademicosModule = () => {
  return (
    <ContainerTemplate active={ROUTES.nivelesAcademicos} routes={[ROUTES.root]}>
      <NivelesAcademicosView />
    </ContainerTemplate>
  );
};

export default NivelesAcademicosModule;
